import loadable from '@loadable/component';

export const LtmSiteWrapper = loadable(
  () => import(/* webpackChunkName: "ltm-site" */ './LtmSiteWrapper'),
);
